// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__197Hc","fullView":"styles_fullView__2ByRb"};